import { MapPin } from "lucide-react";

const ServiceAreaSection = () => {
  const serviceAreas = [
    "Houston",
    "The Woodlands",
    "Sugar Land",
    "Katy",
    "Pearland",
    "Cypress",
    "Spring",
    "Pasadena",
  ];

  return (
    <section
      id="service-area"
      className="section-padding bg-white"
      data-testid="service-area-section"
    >
      <div className="container-custom">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div>
            <span className="inline-block px-4 py-2 bg-sky-100 text-sky-700 rounded-full text-sm font-medium mb-4">
              Service Area
            </span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-slate-900 mb-6">
              Serving Houston & Surrounding Communities
            </h2>
            <p className="text-lg text-slate-600 mb-8">
              We proudly provide professional house cleaning services to homeowners 
              throughout the Greater Houston area. Our team is ready to bring cleanliness 
              and comfort to your home.
            </p>

            {/* Areas Grid */}
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-3" data-testid="service-areas-grid">
              {serviceAreas.map((area, index) => (
                <div
                  key={index}
                  className="flex items-center gap-2 bg-slate-50 rounded-lg px-4 py-3"
                  data-testid={`area-${area.toLowerCase().replace(/\s/g, '-')}`}
                >
                  <MapPin className="w-4 h-4 text-sky-600 flex-shrink-0" />
                  <span className="text-slate-700 font-medium text-sm">{area}</span>
                </div>
              ))}
            </div>

            <p className="mt-6 text-slate-500 text-sm">
              Don't see your area? Contact us to check availability in your neighborhood.
            </p>
          </div>

          {/* Map/Image */}
          <div className="relative">
            <img
              src="https://images.unsplash.com/photo-1725042893312-5ec0dea9e369?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHw0fHxjbGVhbiUyMG1vZGVybiUyMGxpdmluZyUyMHJvb20lMjBpbnRlcmlvciUyMGJyaWdodHxlbnwwfHx8fDE3NzI3MjcxOTV8MA&ixlib=rb-4.1.0&q=85"
              alt="Clean modern home"
              className="rounded-2xl shadow-xl w-full h-[400px] object-cover"
              data-testid="service-area-image"
            />
            {/* Floating Card */}
            <div className="absolute -bottom-6 -left-6 bg-white rounded-xl shadow-xl p-6 hidden md:block">
              <div className="flex items-center gap-4">
                <div className="w-14 h-14 rounded-full bg-sky-100 flex items-center justify-center">
                  <MapPin className="w-7 h-7 text-sky-600" />
                </div>
                <div>
                  <p className="text-2xl font-bold text-slate-900">8+</p>
                  <p className="text-slate-600">Areas Served</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceAreaSection;
